import { Controller } from "@hotwired/stimulus";
import { WebAuthnSigner } from "@dfns/sdk-browser";
import { storage } from "../../../storageconstants";
import httpService from "../../../services/HttpService";
import { debugError, debugLog } from "../../../utils";
import { errorToastMessages, isUserCancellation, showErrorCard, showErrorToast } from "../../../errorsurfaces";

export default class AuthorisationDFNSWithPermitSupportController extends Controller {
  static values = {
    checkoutid:          String,
    challenge:           String,
    session:             String,
    address:             String,
    permit:              String,
    keycredential:       Boolean,
  }

  initialize() {
    this.attestation = null;
    this.domain = JSON.parse(sessionStorage.getItem(storage.DOMAIN));
  }

  async connect() {
    this.hideLoadingScreen();
    this.challenge = JSON.parse(this.challengeValue);
    this.permit = JSON.parse(this.permitValue);
  }

  async handleSignChallenge() {
    this.showLoadingScreen();

    try {
      if (!this.challenge) throw new Error("No challenge available to sign");
      if (!this.domain)    throw new Error("Domain data not available");

      if (this.keycredentialValue) {
        debugLog("Using keycredential for signing");

        let signResonse = await httpService.post(`/sign/`, {
          challenge: this.challenge,
          session: this.sessionValue
        });

        if (signResonse.error) {
          this.hideLoadingScreen();
          debugError(signResonse.error);
          throw new Error(signResonse.error);
        }

        debugLog("KeyCredential signing successful:", signResonse.data);

        this.attestation = signResonse.data;
      } else {
        debugLog("Starting WebAuthn signing for stored challenge");

        const webauthn = new WebAuthnSigner({
          relyingParty: {
            id: this.domain.domain,
            name: this.domain.company,
          },
        });

        this.attestation = await webauthn.sign(this.challenge);
      }

      this.handleDFNSPermitRequest();
    } catch (error) {
      debugLog("Error during WebAuthn signing:", error);
      this.hideLoadingScreen();
      if (isUserCancellation(error)) {
        showErrorToast(errorToastMessages.passkeyCancelled);
      } else {
        showErrorCard("signing-failed", { session: this.sessionValue });
      }
    }
  }

  async handleDFNSPermitRequest() {
    const form = document.getElementById("frame-post-form");
    document.getElementById("form_challengeIdentifier").value = this.challenge.challengeIdentifier;
    document.getElementById("form_firstFactor").value = JSON.stringify(this.attestation);
    document.getElementById("form_session").value = this.sessionValue;
    document.getElementById("form_permitData").value = JSON.stringify({
      ...this.permit,
      address: this.addressValue,
      checkoutid: this.checkoutidValue,
    });
    form.action = `/${sessionStorage.getItem(storage.CODE)}/authorized-review/`;
    form.requestSubmit();
  }

  showLoadingScreen() {
    this.dispatch("showLoadingScreen", { detail: { text: "Please Wait" } });
  }

  hideLoadingScreen() {
    this.dispatch("hideLoadingScreen");
  }
}
